import { NewPaymentMethodDelegate } from 'billing/payment-methods/PaymentMethodsRootViewModel'
import Member from 'iam/models/Member'
import BillingStore from 'billing/BillingStore'
import { CancellationToken } from 'infra/cancellation'
import { computed, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import { ConfirmViewModel } from 'components/ConfirmDialog/ConfirmViewModel'
import BillingMethod from 'billing/models/BillingMethod'

export default class ProfilePaymentMethodsViewModel {
  deleteConfirmDialog = new ConfirmViewModel()

  constructor(
    public member: Member,
    private billingStore: BillingStore,
    private newPaymentMethod: NewPaymentMethodDelegate,
  ) {
    makeObservable(this)
  }

  activate = task(async () => {
    await this.billingStore.fetchBillingProfileForIndividual(
      this.member.workspace.id,
      this.member.user.publicId,
    )
  })

  @computed
  get paymentMethods() {
    const billingProfile = this.billingStore.billingProfiles.find(
      (p) =>
        p.userId === this.member.user.id &&
        p.workspace === this.member.workspace,
    )

    return billingProfile?.billingMethods.slice() ?? []
  }

  /**
   * Add a payment method.
   */
  addPaymentMethod = task.resolved(async () => {
    const method = await this.newPaymentMethod(
      this.member,
      null,
      CancellationToken.default,
    )

    if (!method) {
      return
    }

    await this.setDefaulPaymentMethod(method)
  })

  /**
   * Sets the default team billing method.
   * @param {*} method
   */
  setDefaulPaymentMethod = task.resolved(async (method: BillingMethod) => {
    await this.billingStore.changeDefaultBillingMethod(method)
  })
}
